// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1EfcL","content":"styles_content__36rSw","selectAll":"styles_selectAll__1BL7q"};